// Port do Spinner Airbnb de leyro.es.

export interface SpinnerProps {
  size?: number;
  className?: string;
}

export default function Spinner({ size = 24, className = '' }: SpinnerProps) {
  return (
    <div
      className={`inline-block border-2 border-border border-t-dark rounded-full animate-spin ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
